import { $, Disclosure } from '@starberry/components';

import valuationFields from 'base/defaults/forms/valuation.json';

export default {
  component: Disclosure,
  props: {
    render:
      () =>
      ({ isOpen, onClose, onOpen }) => {
        return {
          $: 'Stack',
          props: {
            direction: 'column',
            spacing: 0,
          },
          children: [
            {
              $: 'PrimaryButton',
              props: {
                onClick: () => onOpen,
                mt: 7,
              },
              children: $('constants.translations.valuationCard.VALUATION_CTA_BUTTON', 'Valuation'),
            },
            {
              $: 'FormDialog',
              isOpen: isOpen,
              onClose: () => onClose,
              fields: valuationFields,
            },
          ],
        };
      },
  },
};
